/**
 * Protocolo del `RTCDataChannel`.
 *
 * En la fase 1 solo lleva ping/pong para medir el round-trip. Los mensajes de
 * ratón y teclado se añaden a esta misma unión en la fase 3, y el discriminante
 * `t` sigue siendo el mismo, así que el `switch` del agente no cambia de forma.
 */
export const CONTROL_CHANNEL_LABEL = 'control';
export function encodeControlMessage(message) {
    return JSON.stringify(message);
}
//# sourceMappingURL=control.js.map